import { apiClient } from './api';
import { ApiResponse } from '../types';
import { Alert, AlertStats } from '../types/alert';

export const alertService = {
  // Get all alerts
  getAlerts: async (
    status?: 'active' | 'acknowledged' | 'resolved',
  ): Promise<ApiResponse<Alert[]>> => {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    params.set('limit', '500');  // load all, pagination is client-side
    const qs = params.toString();
    return apiClient.get(`/alerts${qs ? `?${qs}` : ''}`);
  },

  // Get alert statistics (vraci primo objekt, ne ApiResponse wrapper)
  getAlertStats: async (): Promise<AlertStats> => {
    return apiClient.get('/alerts/stats');
  },

  // Acknowledge an alert
  acknowledgeAlert: async (alertId: number): Promise<ApiResponse<Alert>> => {
    return apiClient.patch(`/alerts/${alertId}/acknowledge`);
  },

  // Acknowledge multiple alerts
  acknowledgeMultiple: async (alertIds: number[]): Promise<ApiResponse<void>> => {
    return apiClient.post('/alerts/acknowledge-multiple', { alertIds });
  },

  // Clear old alerts (delete acknowledged alerts older than specified days)
  clearOldAlerts: async (daysOld: number = 30): Promise<ApiResponse<void>> => {
    return apiClient.delete(`/alerts/clear-old?days=${daysOld}`);
  },

  // Resolve an alert (mark as resolved)
  resolveAlert: async (alertId: number): Promise<ApiResponse<Alert>> => {
    return apiClient.put(`/alerts/${alertId}/resolve`);
  },

  // Resolve multiple alerts
  resolveMultiple: async (alertIds: number[]): Promise<ApiResponse<void>> => {
    return apiClient.post('/alerts/resolve-multiple', { alertIds });
  },
};
